<template>
  <span
    class="iconify svg--close text-xl"
    @click="toggleNavigation"
  />
</template>

<script>


export default defineComponent({
  name: 'CloseNavigation',
  setup() {

    const { toggleNavigation } = useNavigationState();

    return {
      toggleNavigation,
    };
  
  },
});

</script>
